module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "c16"
    }
  }, [_c('div', {
    staticClass: "chbrd"
  }, [_c('h1', {
    staticClass: "chapter_date"
  }, [_c('a', {
    attrs: {
      "id": "page42"
    }
  }), _c('strong', [_vm._v("c. 450 BCE")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter_title"
  }, [_vm._v("Survival of the Fittest")]), _vm._v(" "), _c('p', {
    staticClass: "bauthorb"
  }, [_c('strong', [_vm._v("Empedocles")]), _vm._v(" (c. 490–430 BCE)")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Early Greek philosophers often combined science and religion in ways that strike us as strange. The philosopher-poet Empedocles offers a prime example. He was born in Acragas (modern-day Agrigento), a Greek colony in Sicily. For a time he studied with the Pythagoreans, taking to heart their beliefs in reincarnation and vegetarianism. According to legend, Empedocles declared himself to be a god who had been condemned to a series of earthly rebirths as punishment for some celestial crime. It is said that he ended his life by leaping into the crater of Mount Etna to prove his immortality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is the scientific side of Empedocles’s thought that is of more lasting significance. He was an eclectic thinker who sought to synthesize a number of conflicting views of his predecessors. For example, he agreed with Parmenides that reality must be eternal, material, and in some sense unchanging. At the same time, the reality of change is too obvious to be denied. His solution was to distinguish two levels of reality. At the micro-level there are four elements—earth, air, fire, and water—that are eternal and indestructible. These mix to form larger objects—trees, clouds, horses, and so forth—that undergo constant change. This doctrine of the four basic elements survived until the birth of modern science.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Empedocles also sought to explain natural phenomena in terms of two fundamental forces that he called Love and Hate. Love is a force of attraction that binds things together, while Hate is a force of repulsion that breaks them apart. For all eternity, these two powers wax and wane in endlessly repeating cosmic cycles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To explain the origin of living creatures, Empedocles proposed a theory of evolution. Random mixing of the four elements produced bone, flesh, etc., which united to form primitive organisms. Because of the haphazard way these organisms were formed, most were oddly shaped and quickly died out. Through a slow process of natural selection and survival of the fittest, the better-adapted animals (including us humans) are here today. In recognition of his prescient theory, Empedocles earned a shout-out in Charles Darwin’s "), _c('em', [_vm._v("Origin of Species.")])]), _vm._v(" "), _c('p', {
    staticClass: "captionl",
    attrs: {
      "id": "img43"
    }
  }, [_c('em', [_vm._v("The philosopher-poet Empedocles—who supposedly declared himself to be a god—looks to the heavens in an early-sixteenth-century French engraving.")])]), _vm._v(" "), _c('div', {
    staticClass: "dis_imgb"
  }, [_c('a', {
    attrs: {
      "id": "page43"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/43-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xref"
  }, [_c('p', {
    staticClass: "seal"
  }, [_c('span', {
    staticClass: "sls"
  }, [_c('strong', [_vm._v("SEE ALSO")])]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c13"
    }
  }, [_vm._v("Change Is Illusory (c. 470 BCE)")]), _vm._v(", "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c14"
    }
  }, [_vm._v("Mind Organizes Nature (c. 460 BCE)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454935575_c153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Darwin’s "), _c('em', [_vm._v("Origin of Species")]), _vm._v(" (1859)")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dce4a1b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781454935575_c16.vue
// module id = 120
// module chunks = 0